<div *ngIf="room" id="room-detail-component">

  <!-- Gallery (hidden) -->
  <div class="section-gallery">
    <div id="gallery" class="pswp-gallery pswp-gallery--single-column">
      <a *ngFor="let image of images"
         [href]="image.filePath"
         [attr.data-pswp-src]="image.filePath"
         [attr.data-pswp-width]="image.width || 1024"
         [attr.data-pswp-height]="image.height || 682">
      </a>
    </div>
  </div>

  <!-- Hero -->
  <div class="section-hero" (click)="showGallery(0);">
    <div class="top-fold" [style]="{'background-image': 'url(&quot;' + ((room.largeImages && room.largeImages.length > 0) ? room!.largeImages![0].filePath : '/images/conference-room/room-detail/room-default.webp') + '&quot;)'}">

      <div class="overlay">

        <!-- Back button -->
        <div class="overlay-left">
          <a routerLink="{{ previousPath }}" queryParamsHandling="preserve" class="btn btn-default btn-back" (click)="$event.stopPropagation()">
            <i class="bi bi-chevron-left ps-1 pe-1"></i>
          </a>
        </div>

      </div>
    </div>
  </div>

  <br/>

  <!-- Title & Location -->
  <div class="section-title" *ngIf="region && room">
    <div class="container g-5">
      <div class="row">
        <div class="col-8 col-sm-9 col-lg-10 col-xxl-10">
          <h2 class="name">{{ room.name }}</h2>
          <p class="neighborhood" *ngIf="room.place!.location!">
            <span *ngIf="regionSlug && neighborhoodSlug && placeSlug"><a [routerLink]="['/conference-room', regionSlug, neighborhoodSlug, placeSlug]">{{ room.place!.name }}</a></span>
            <span *ngIf="regionSlug && neighborhoodSlug && placeSlug">&nbsp;•&nbsp;</span>
            <span *ngIf="regionSlug && neighborhoodSlug"><a [routerLink]="['/conference-room', regionSlug, neighborhoodSlug]">{{ room!.place!.location!.neighborhood }}</a></span>
            <span *ngIf="regionSlug && neighborhoodSlug">&nbsp;•&nbsp;</span>
            <span *ngIf="regionSlug"><a [routerLink]="['/conference-room', regionSlug]">{{ region!.name! }}</a></span>
          </p>
          <p class="neighborhood" *ngIf="room!.place!.location">
            <a target="_blank"
               href="{{ room!.place!.useCoordinates
                ? ('https://maps.google.com/?q=' + room.place!.location!.latitude! + ',' + room.place!.location!.longitude!)
                : ('https://maps.google.com/?q=' + room.place!.location!.address! + ', ' + room.place!.location!.city! + ', ' + room.place!.location!.state! + ' ' + room.place!.location!.zipcode!)}}">
              <span>{{ room.place!.location!.address }}, </span>
              <span *ngIf="room!.place!.location.address2">{{ room.place!.location!.address2 }}, </span>
              <span>{{ room.place!.location!.city }}, </span>
              <span>{{ room.place!.location!.state }} </span>
              <span>{{ room.place!.location!.zipcode }}</span>
            </a>
          </p>
        </div>

        <div class="col-4 col-sm-3 col-lg-2 col-xxl-2">
          <div class="text-end">
            <div class="rate">
              <h1>{{room!.maxSeats!}} <i class="bi bi-person-fill"></i></h1>
              <span>{{ room!.hourlyRate! / 100 | money: room.currency! : 2 : false }}/hr</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Availability -->
  <div class="section-availability">
    <div class="container g-5">
      <div class="row">
        <div class="col">
          <div class="availability-box">
            <h4>Find Availability</h4>
            <br/>

            <form id="schedule" (ngSubmit)="loadSchedule()" (change)="loadSchedule()" ngNativeValidate>

              <!-- Date -->
              <div class="row">
                <div class="col-12">
                  <div class="input-group input-group-lg">
                    <select name="reserveDate" class="form-select" [(ngModel)]="reserveDate" required>
                      <option *ngFor="let option of reserveDateOptions" [value]="option.value">{{option.label}}</option>
                    </select>
                  </div>
                  <br/>
                </div>

                <!-- Time -->
                <div class="col-12 col-sm-6">
                  <div class="input-group input-group-lg">
                    <select name="reserveTime" class="form-select" [(ngModel)]="reserveTime" required>
                      <option *ngFor="let option of reserveTimeOptions" [value]="option.value">{{option.label}}</option>
                    </select>
                  </div>
                  <br/>
                </div>

                <!-- Duration -->
                <div class="col-12 col-sm-6">
                  <div class="input-group input-group-lg">
                    <select name="duration" class="form-select" [(ngModel)]="reserveDuration" required>
                      <option *ngFor="let option of reserveDurationOptions" [value]="option.value">{{option.label}}</option>
                    </select>
                  </div>
                  <br/>
                </div>
              </div>
            </form>

            <!-- No availability -->
            <div *ngIf="isScheduleLoaded && !selectedAvailability && !isScheduleLoading">
              <div class="alert alert-danger" role="alert">
                Sorry we found no availability on {{reserve | moment: "ddd, MMM Do, YYYY"}} {{reserve | moment: "h:mm A"}}. Please try another timeframe.
              </div>
            </div>

            <!-- Check availability -->
            <button class="btn btn-block btn-neon-blue" form="schedule" [disabled]="isScheduleLoading" *ngIf="!selectedAvailability">
              <span>Check Availability</span>
              <span *ngIf="isScheduleLoading" class="spinner-border spinner-border-sm ms-2"></span>
            </button>

            <!-- Booking results -->
            <form id="booking" (ngSubmit)="bookRoom()" ngNativeValidate>
              <div *ngIf="schedule && schedule.availabilities.length > 0">
                <label *ngFor="let availability of schedule.availabilities">
                  <div class="radio-item">
                    <input type="radio" name="availability" [value]="availability" [(ngModel)]="selectedAvailability" (change)="loadBookingPrices()" required/>
                    <div><strong>{{availability.localBegin | moment: "ddd, MMM Do, YYYY"}}, {{availability.localBegin | moment: "h:mm A"}} to {{availability.localEnd | moment: "h:mm A"}}</strong></div>
                  </div>
                </label>
                <br/>
              </div>
            </form>

            <!-- Booking price -->
            <div *ngIf="bookingPrice">
              <hr/>

              <div class="row">
                <div class="col">

                </div>
                <div class="col">
                  <div class="text-end">
                    <p><small>{{reserveDuration}} hours x {{ room!.hourlyRate! / 100 | money: room.currency! : 2 : false }}/hr</small></p>
                    <h3>Total: {{ bookingPrice!.totalBalance! / 100 | money: room.currency! : 2 : false }}</h3>
                  </div>
                </div>
              </div>

              <br/>
            </div>

            <!-- Booking -->
            <button class="btn btn-block btn-yellow" form="booking" [disabled]="isScheduleLoading || isBookingPriceLoading" *ngIf="selectedAvailability">
              <span>Book Conference Room</span>
              <span *ngIf="isScheduleLoading || isBookingPriceLoading" class="spinner-border spinner-border-sm ms-2"></span>
            </button>

            <!-- Cancellation policy -->
            <div class="text-center mt-2">
              <small><strong>Cancellation policy:</strong> Full refund with two hour advance notice. Cancel via app or website.</small>
            </div>

          </div>
        </div>
      </div>
    </div>

    <br/>
  </div>

  <!-- Hours -->
  <div class="section-hours" *ngIf="place">
    <hr/>
    <br/>
    <div class="container g-5">
      <div class="row">
        <div class="col">
          <h3>Hours</h3>
          <app-place-detail-hours [place]="place"></app-place-detail-hours>
        </div>
      </div>
    </div>
    <br/>
  </div>

  <!-- Additional rooms-->
  <div class="section-additional-rooms" *ngIf="otherRooms.length > 0">
    <hr/>
    <br/>

    <div class="container g-5">
      <div class="row">
        <div class="col-12">
          <h3>Other conference rooms at {{room!.place!.name! }}</h3>
          <br/>
        </div>

        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-4 col-xxl-3" *ngFor="let otherRoom of otherRooms">
          <app-room-box [room]="otherRoom" [showPlaceNameAndNeighborhoodText]="false" [showCapacityAndPriceText]="true"/>
          <br/>
        </div>
      </div>
    </div>

    <br/>
    <br/>
  </div>

  <!-- Map (Mobile & Tablet) -->
  <div class="section-map hide-xl hide-xxl" *ngIf="room!.place!.location">
    <hr/>
    <br/>

    <div class="container g-5">
      <div class="row">
        <div class="col">
          <h3>Location</h3>
          <br/>

          <a target="_blank"
             href="{{ room!.place!.useCoordinates
             ? ('https://maps.google.com/?q=' + room!.place!.location!.latitude + ',' + room!.place!.location!.longitude)
             : ('https://maps.google.com/?q=' + room!.place!.location!.address + ', ' + room!.place!.location!.city + ', ' + room!.place!.location!.state + ' ' + room!.place!.location!.zipcode)}}">
            <img class="img-responsive"
                 src="https://maps.googleapis.com/maps/api/staticmap?center={{ room!.place!.location!.latitude }},{{ room!.place!.location!.longitude }}&zoom=15&size=800x400&maptype=roadmap%20&markers=color:red%7Clabel:%26%238226%3B%7C{{ room!.place!.location!.latitude }},{{ room!.place!.location!.longitude }}&key={{ GOOGLE_MAP_API_KEY }}"
                 alt="Location Map"/>
          </a>
        </div>
      </div>
    </div>
  </div>

  <br/>
  <br/>
  <br/>

</div>

<!-- Loading -->
<div class="container-fluid" *ngIf="loading">
  <div class="text-center">
    <br/>
    <br/>
    <span class="spinner-border"></span>
    <br/>
    <br/>
  </div>
</div>
